<template>
  <v-layout
    wrap
    class="bg-summary pa-4 mt-4"
  >
    <v-flex>
      <p class="text-xs-right display-1 sz_grafit--text">
        {{ title }}
      </p>
    </v-flex>
    <v-flex xs12>
      <p class="text-xs-right mb-0 value sz_grafit--text">
        {{ value }}<span class="pl-2 small">PLN</span>
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'MoneySummary',
    props: {
        value: {
            default: 0
        },
        title: {
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
.bg-summary {
  background-color: #e9eaea;
  .value {
    font-size: 28px;
    font-weight: 600;
    line-height: 24px;
    .small {
      font-size: 18px;
    }
  }
}
</style>
